import { BlackFridayBanner } from "@/components/BlackFridayBanner";
import { Footer } from "@/components/Footer";
import { createFileRoute, Link, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout")({
	component: RouteComponent,
});

function RouteComponent() {
	return (
		<div className="flex flex-col min-h-screen">
			{/* Black Friday Banner - Outside padded content */}
			<BlackFridayBanner />

			{/* Window Content with padding */}
			<div className="window-content flex flex-1 items-start justify-center">
				<div className="flex h-full w-full max-w-6xl flex-1 flex-col ">
					<div className="mb-4 md:mb-6 flex items-center justify-between px-0 md:px-6">
					<Link
						to="/"
						className="font-serif-600 text-xl md:text-2xl text-black hover:text-gray-600 transition-colors duration-200 cursor-pointer"
					>
						Macrowave
					</Link>

					{/* Actions */}
					<div className="flex items-center gap-4 md:gap-6">
						{/* About Link */}
						<Link
							to="/buy"
							className="font-serif text-gray-600 hover:text-black transition-colors duration-200 cursor-pointer"
						>
							Buy
						</Link>

						{/* Blog Link */}
						<Link
							to="/blog"
							className="font-serif text-gray-600 hover:text-black transition-colors duration-200 cursor-pointer"
						>
							Blog
						</Link>

						{/* Embed Link */}
						<Link
							to="/embed"
							className="font-serif text-gray-600 hover:text-black transition-colors duration-200 cursor-pointer"
						>
							Embed
						</Link>

						<a
							href="/discord"
							target="_blank"
							rel="noopener noreferrer"
							className="font-serif text-gray-600 hover:text-black transition-colors duration-200 cursor-pointer"
						>
							Discord
						</a>

						{/* Auth Button */}
						{/* <AuthButton /> */}
					</div>
				</div>
					<div className="flex-1 px-0 md:px-6 min-h-[calc(100vh-16rem)]">
						<Outlet />
					</div>
					<Footer />
				</div>
			</div>
		</div>
	);
}
